import {
    SkyDataGridColumnDefinition,
} from 'app/PoC/DataGridDemoPages/components/SkyBaseDataGrid'
import {
    FilterType,
} from 'app/enums/common.enums'
import {
    OrderStatuses,
    OrderTypes,
    ProductType,
} from 'app/enums/label.enums'

import {
    OutboundOrdersType,
} from 'app/Apps/ContainerManagement/ServiceCenters/ScenarioEditor/ScenarioEditor.types'

const columns: SkyDataGridColumnDefinition<OutboundOrdersType>[] = [
    {
        name: 'orderNumber',
        componentName: 'OrderTableLink',
        labelKey: 'ORDER',
        width: 130,
    },
    {
        name: 'orderStatus',
        componentName: 'EnumValue',
        allowedValuesEnum: OrderStatuses,
        filterField: 'orderStatus',
        filterType: FilterType.Array,
        labelKey: 'ORDER_STATUS',
    },
    {
        name: 'orderType',
        componentName: 'EnumValue',
        allowedValuesEnum: OrderTypes,
        labelKey: 'ORDER_TYPE',
        filterField: 'orderType',
        filterType: FilterType.Array,
    },
    {
        name: 'from',
        labelKey: 'FROM',
    },
    {
        name: 'to',
        labelKey: 'TO',
    },
    {
        name: 'customerLocationName',
        filterField: 'customerLocationName',
        filterType: FilterType.Array,
        labelKey: 'CUSTOMER',
    },
    {
        name: 'pricingAccountCompanyName',
        filterField: 'pricingAccountCompanyName',
        filterType: FilterType.Array,
        labelKey: 'PRICING_ACCOUNT',
    },
    {
        name: 'estimatedPickup',
        sorting: false,
        labelKey: 'ESTIMATED_PICK-UP',
    },
    {
        name: 'requiredContainers',
        componentName: 'RequiredContainersList',
        allowedValuesEnum: ProductType,
        sorting: false,
        labelKey: 'REQUIRED_CONTAINERS',
        filterField: 'requiredContainers',
        filterType: FilterType.Array,
        minWidth: 180,
    },
]

export default columns
